import { FaCode, FaConnectdevelop } from "react-icons/fa";
import { MdOutlineDevices, MdOutlineDevicesOther } from "react-icons/md";
import { TbDeviceDesktopAnalytics } from "react-icons/tb";
import { GrHostMaintenance } from "react-icons/gr";

const servicesData = [
  {
    icon: <FaCode className="text-2xl" />,
    title: "Web & Mobile Development",
    description:
      "Custom websites and mobile applications tailored to your business needs, using cutting-edge technologies for performance and scalability.",
    imageSrc:
      "https://images.pexels.com/photos/1181216/pexels-photo-1181216.jpeg",
    bgColor: "bg-white",
  },
  {
    icon: <MdOutlineDevices className="text-2xl" />,
    title: "UI/UX Design",
    description:
      "User-centric design solutions that enhance engagement, usability, and brand consistency across digital platforms.",
    imageSrc:
      "https://images.pexels.com/photos/34212988/pexels-photo-34212988.jpeg",
    bgColor: "bg-white",
  },
  {
    icon: <MdOutlineDevicesOther className="text-2xl" />,
    title: "Digital Transformation",
    description:
      "Helping businesses embrace modern digital tools and processes to improve efficiency, innovation, and customer experience.",
    imageSrc:
      "https://images.pexels.com/photos/9783812/pexels-photo-9783812.jpeg",
    bgColor: "bg-white",
  },
  {
    icon: <TbDeviceDesktopAnalytics className="text-2xl" />,
    title: "Software Solutions",
    description:
      "Tailored software development services for businesses, including automation, enterprise tools, and integrations.",
    imageSrc:
      "https://images.pexels.com/photos/15555858/pexels-photo-15555858.jpeg",
    bgColor: "bg-white",
  },
  {
    icon: <FaConnectdevelop className="text-2xl" />,
    title: "Consulting & Strategy",
    description:
      "Expert guidance on technology adoption, digital strategy, and operational improvements to accelerate growth.",
    imageSrc:
      "https://framerusercontent.com/images/8M5ylKKutuICwnx9s3GURayjYQ.jpg?scale-down-to=2048",
    bgColor: "bg-white",
  },
  {
    icon: <GrHostMaintenance className="text-2xl" />,
    title: "Maintenance & Support",
    description:
      "Reliable post-launch support and maintenance to ensure your digital assets remain secure, fast, and up-to-date.",
    imageSrc:
      "https://framerusercontent.com/images/9KyWAYBvYkUbASCckXa16Fgc.jpg?scale-down-to=512",
    bgColor: "bg-white",
  },
];

export default servicesData;
